export class CiResultFixedData {

    slug: string; //  "know"
    iconClasses: string; // 'fa-kit fa-solid-globe-magnifying-glass'
    titleTranslationKey: string; //  "ciprofile_domains.know"
    children ? :  CiResultFixedData[]

}